"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StickyContent = styled_components_1.default.div `
  flex: auto;
  overflow: auto;
  position: relative;
`;
//# sourceMappingURL=sticky-content.js.map